class ProfileCtrl {
  constructor(AuthService, FlashService, $state) {
    'ngInject';
    Object.assign(this, {AuthService, FlashService, $state});
    
    this.userMessages = [];
    this.profile = {};
    
    this.AuthService.user().then( user => {
      this.user = user;
      const { displayName, email, phoneNumber } = this.AuthService.getProfile();
      this.profile = { displayName, email, phoneNumber };
    });
  }
  
  async submit(user, profile){
    this.userMessages = []; // Reset on submit
    try {
      await this.AuthService.updateProfile(profile, user);
      this.FlashService.success("Profile Updated");
      this.$state.go('app.form-builder');
      
    } catch (error) {
      this.FlashService.error(error.message);
      this.userMessages.push({"class":"alert-danger", "message": error.message});
    }
  }

}

export default {
  bindings: {
  },
  templateUrl: "user/profile/profile.component.html",
  controller: ProfileCtrl
}
